import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum MessageTypeEnum {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success",
}

export interface MessageType {
  type: MessageTypeEnum;
  display: "toaster" | "bar";
  title?: string;
  description?: string;
}

interface ErrorState {
  message?: MessageType;
}

const initialState: ErrorState = {
  message: undefined,
};

const messageSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<MessageType | undefined>) => {
      state.message = action.payload;
    },
  },
});

export const { setMessage } = messageSlice.actions;
export default messageSlice.reducer;
